module.exports = __webpack_public_path__ + "img/krasnoschekov_500.1771b55e.jpg";